import React, { useRef } from 'react'
import { Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import useTranslate from '../../../../../i18n/useTranslate'
import useSignRepresent from './useSignRepresent'
import { ButtonSign } from '../pageAction'
import Dialog from '../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../control/accordion/accordion'
import Checkbox from '../../../../../control/checkbox/checkbox'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import constSubmittedStatus from '../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../constants/submittedStep'

type ErrorsType = {
    chairmanSign?: string
    secretarySign?: string
}
export type SignRepresentREC2ViewType = ReturnType<typeof useSignRepresent>
const SignRepresentREC2View = (props: SignRepresentREC2ViewType) => {
    const {
        onRefDialog,
        configDialog,
        isViewMode,
        initialValues,
        handleDirtyChange,
        onSubmitForm,
        initialUploadFileCer,
        certificateTopicList,
        projectData,
    } = props

    const translate = useTranslate()
    const isFirstTime = useRef<boolean>(true)
    //มีการลงนามไปแล้ว
    const isSigning: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                uploadFile: initialUploadFileCer,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!initialValues.chairmanSign && !initialValues.secretarySign) {
                    /* case1 ยังไม่มีค่าใดถูกเลือกเลย */
                    if (!values.secretarySign && !values.chairmanSign) {
                        // errors.chairmanSign = 'กรุณาระบุค่า'

                        // errors.secretarySign = ' '
                        errors.chairmanSign = translate.get('MESSAGE.M016')
                        errors.secretarySign = translate.get('MESSAGE.M016')
                    }
                } else if (initialValues.chairmanSign) {
                    /* case2  ประธานถูกเลือกไว้แล้ว */
                    if (!values.secretarySign) {
                        // errors.secretarySign = 'กรุณาระบุค่า'
                        errors.secretarySign = translate.get('MESSAGE.M016')
                    }
                } else if (initialValues.secretarySign) {
                    /* case3  เลขาถูกเลือกไว้แล้ว */
                    if (!values.chairmanSign) {
                        // errors.chairmanSign = 'กรุณาระบุค่า'
                        errors.chairmanSign = translate.get('MESSAGE.M016')
                    }
                }
                return errors
            }}
        >
            {(props) => {
                return (
                    <React.Fragment>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.SIGNED_SUBSTITUTION')}>
                                    <Grid item xs={12} md={3} lg={2} xl={1}>
                                        <Checkbox
                                            name="chairmanSign"
                                            label={translate.get('LABEL.PRESIDENT')}
                                            disabled={isViewMode || initialValues.chairmanSign}
                                            onChangeValue={() => {
                                                isFirstTime.current = false
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9} lg={10} xl={11}>
                                        <Checkbox
                                            name="secretarySign"
                                            label={translate.get('LABEL.SECRETARY')}
                                            disabled={isViewMode || initialValues.secretarySign}
                                            onChangeValue={() => {
                                                isFirstTime.current = false
                                            }}
                                        />
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {isSigning && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        initialData={initialUploadFileCer}
                                        documentTitleList={certificateTopicList}
                                        title={translate.get('LABEL.CERTIFICATE_SIGN')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {!isViewMode && (
                            <ButtonSign
                                onClickSave={() => {
                                    props.form.change('saveType', 'SAVE')
                                    props.handleSubmit()
                                }}
                            />
                        )}
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type SignRepresentREC2Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const SignRepresentREC2 = (props: SignRepresentREC2Type) => {
    const signRepresent = useSignRepresent(props)
    return <SignRepresentREC2View {...signRepresent} />
}

export default SignRepresentREC2
